
















const namespace = 'calendar';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IFilters, IFilter } from '@/modules/calendar/interfaces/IFilter';

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface IWeekDay {
    label: string;
    id: number;
    isActive: boolean;
}

@Component({
    name: 'CalendarPills',
})
export default class CalendarPills extends Vue {
    @Prop() public filters!: IFilters;
    @Getter('weekdaysContainerWidth', { namespace }) private weekdaysContainerWidth!: number;
    @Getter('hiddenFilters', { namespace }) private hiddenFiltersList!: string;
    private odataName = 'WeekDayId';
    private weekDays: IWeekDay[] = [
        {
            label: 'All Days',
            id: 0,
            isActive: true,
        },
        // {
        //     label: 'Monday',
        //     id: 1,
        //     isActive: false,
        // },
        // {
        //     label: 'Tuesday',
        //     id: 2,
        //     isActive: false,
        // },
        // {
        //     label: 'Wednesday',
        //     id: 3,
        //     isActive: false,
        // },
        {
            label: 'Thursday',
            id: 4,
            isActive: false,
        },
        {
            label: 'Friday',
            id: 5,
            isActive: false,
        },
        {
            label: 'Saturday',
            id: 6,
            isActive: false,
        },
        {
            label: 'Sunday',
            id: 7,
            isActive: false,
        },
    ];

    private get hiddenFilters() {
        return this.hiddenFiltersList.split(',');
    }

    public isHidden(name: string): boolean {
        const contain = this.hiddenFilters ? this.hiddenFilters.filter(hiddenFilter => hiddenFilter === name) : [];
        return contain.length === 1 ? true : false;
    }

    private get getFilters() {
        return this.filters;
    }

    private updated() {
        if (this.filters[this.odataName] && this.filters[this.odataName].length) {
            this.filters[this.odataName].map((filter: IFilter) => this.checkPill(filter.details.value));
            this.weekDays[0].isActive = false;
        }
    }

    private checkPill(id: number | string) {
        const idx = typeof id === 'string' ? parseInt(id) : id;
        this.weekDays[idx].isActive = true;
    }

    private handlePillClick(id: number): void {
        this.togglePillActive(id);
        const actives: IWeekDay[] = this.weekDays.filter(weekDay => weekDay.isActive === true);
        const weekDayIds: number[] = actives.map(active => active.id);
        const details = this.prepareEqFilter(weekDayIds);
        this.$emit('updateFilters', { odataName: this.odataName, details });
    }

    private togglePillActive(id: number) {
        if (id === 0) {
            this.weekDays.map(weekDay => (weekDay.isActive = false));
            this.weekDays[0].isActive = true;
        } else {
            this.weekDays[id].isActive = !this.weekDays[id].isActive;
            this.weekDays[0].isActive = false;
        }
    }

    private prepareEqFilter(weekDayIds: number[], odataName = 'WeekDayId'): IFilter[] {
        const details: IFilter[] = [];
        if (weekDayIds[0] === 0) {
            return details;
        }
        weekDayIds.forEach((weekDayId: number) => {
            const detail: IFilter = {
                odataName,
                details: {
                    odataName,
                    compareType: 'eq',
                    value: weekDayId,
                },
            };
            details.push(detail);
        });
        return details;
    }
}
